import { defineStore } from 'pinia';
import { KioskService } from '@/common/services/kiosk.service';

export const useKiosksStore = defineStore('KiosksStore', {
  // state
  state: () => ({
    kioskList: [],
  }),

  // getters
  getters: {
    getKiosks() {
      return this.kioskList;
    },
    getKioskById() {
      return function (id) { return this.kioskList.find(el => el.id === id); };
    },
    getCount() {
      return this.kioskList.length;
    },
    getMapped() {
      return function (keys) { return this.kioskList.map(this.mapData(keys)); };
    },
  },

  // actions
  actions: {
    setKiosks() {
      KioskService.query()
        .then((response) => {
          this.$patch({ kioskList: response.data });
        });
    },
    mapData(keys = []) {
      return function (el) {
        const returnData = {};
        keys.forEach(key => returnData[key] = el[key]);
        return returnData;
      };
    },
  },
});
